export const picai = 'http://pzpre.oxldkm.com/#/login';

export const kgame = 'https://www.kgame.com/games';

export const aug = 'https://demo.augaming.com/index_ch.html';
